import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TariffManagementRoutingModule } from './tariff-management-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material.module';
import { TariffManagementComponent } from './tariff-management.component';
import { CreateTariffComponent } from './create/create-tariff.component';


@NgModule({
    declarations: [TariffManagementComponent, CreateTariffComponent],
    imports: [
        CommonModule,
        TariffManagementRoutingModule,
        TranslateModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [
        TariffManagementComponent, CreateTariffComponent
    ]
})
export class TariffManagementModule { }
